// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ user, onLogout }) => {
    const [menuOpen, setMenuOpen] = useState(false);  

    const toggleMenu = () => {
      setMenuOpen((prev) => !prev);
    };

    const closeMenu = () => {
      setMenuOpen(false);
    };

      // Close menu if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuOpen &&
        !event.target.closest('.navbar-container') &&
        !event.target.closest('.burger-menu')
      ) {
        closeMenu();
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuOpen]);



  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-center">
          <div className="burger-menu" onClick={toggleMenu}>
            <div />
            <div />
            <div />
          </div>
          <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            {[
              { path: '/', label: 'Home' },
              { path: '/about', label: 'Our Story' },
              { path: '/event-details', label: 'Event Details' },
              { path: '/wedding-party', label: 'Wedding Party' },
              { path: '/travel', label: 'Travel' },
              // { path: '/gallery', label: 'Gallery' },
              { path: '/registry', label: 'Registry' },
              { path: '/faq', label: 'FAQ' },
              { path: '/rsvp', label: 'RSVP' },
            ].map(({ path, label }) => (
              <li className="nav-item" key={path}>
                <NavLink to={path} className="nav-links" onClick={closeMenu}>
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
